import { useState } from "react";
import { t } from "i18next";
import { Button, Grid, List, Modal, Table, Typography } from "antd";
import Helper from "../../../core/Helper";
import ReactJson from "react-json-view";

export default function LogsPreview({ logs }) {
    // Veri sütunu satır içinde kaydırmalı bir kutuydu ve satırları şişiriyordu;
    // artık düğmeye basınca ayrı pencerede açılıyor.
    const [detail, setDetail] = useState(null);
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    const renderDescription = (row) => {
        if(row.description) {
            return row.description
        }

        if(row.type === 1) {
            return t('CHANGE_APPOINTMENT')
        }
        else if(row.type === 2) {
            return t('DELETE_PAYMENT')
        }
        else if(row.type === 3) {
            return t('CHANGE_APPOINTMENT_INSTITUTION')
        }
        else if(row.type === 4) {
            return t('CREATE_APPOINTMENT')
        }
        else if(row.type === 5) {
            return t('CHANGE_APPOINTMENT_STATE')
        }
        else if(row.type === 6) {
            return t('CREATE_PAYMENT')
        }
        else if(row.type === 7) {
            return t('CHANGE_PAYMENT')
        }
        else if(row.type === 8) {
            return t('DELETE_APPOINTMENT')
        }
        else if(row.type === 9) {
            return t('CHANGE_APPOINTMENT_ENTITLEMENT')
        }
        else if(row.type === 10) {
            return t('APPOINTMENT_STATE_DESCRIPTION')
        }
        else if(row.type === 11) {
            return t('RESTORE_APPOINTMENT')
        }
        else if(row.type === 12) {
            return t('SEND_ENTITLEMENT_CONFIRMATION')
        }
        else if(row.type === 13) {
            return t('CANCEL_ENTITLEMENT_CONFIRMATION')
        }
        else if(row.type === 14) {
            return t('CONFIRM_ENTITLEMENT')
        }
        else if(row.type === 15) {
            return t('DELETE_OPERATIONS')
        }
        else if(row.type === 16) {
            return t('EDIT_OPERATIONS')
        }
        else if(row.type === 17) {
            return t('ADD_OPERATIONS')
        }

        return '-'
    }

    const formatData = (data) => {
        Object.keys(data).forEach(key => {
            const dateKeys = ['paymentDate', 'next_PaymentDate', 'previous_PaymentDate', 'startDate', 'endDate', 'previous_StartDate', 'next_StartDate', 'previous_EndDate', 'next_EndDate']
            if(dateKeys.includes(key)) {
                data[key] = new Date(data[key]).toLocaleString()
            }
        })

        return data
    }

    /** JSON ise ağaç görünümü, değilse '@' ile ayrılmış düz metin. */
    const renderData = (row) => {
        try {
            const data = JSON.parse(row?.data);
            if(typeof data === 'string') {
                throw new Error('Not a JSON');
            }
            return (
                <ReactJson
                    src={formatData(data)}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    collapsed={2}
                />
            )
        }
        catch (exp) {
            return (row?.data || '').replaceAll('"', '').split('@').map((item, index) => {
                return (
                    <div key={index}>{item}</div>
                )
            })
        }
    }

    // Mobil: tablo yerine liste — açıklama tam genişlikte ve satır kırılabilir (tek satır
    // ellipsis dar ekranda okunmuyordu), tarih · kullanıcı altında, veri butonu sağda.
    const renderMobileList = () => (
        <List
            dataSource={logs}
            rowKey={'id'}
            size={'small'}
            pagination={(logs?.length || 0) > 10 ? { pageSize: 10, size: 'small', align: 'center' } : false}
            renderItem={(row) => (
                <List.Item style={{ padding: '10px 0', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ wordBreak: 'break-word' }}>{renderDescription(row)}</div>
                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                            {new Date(row.createdDate).toLocaleString()}
                            {row?.user?.name && ` · ${row.user.name}`}
                        </Typography.Text>
                    </div>
                    {row?.data && (
                        <Button size={'middle'} onClick={() => setDetail(row)} style={{ flexShrink: 0 }}>
                            {t('Show')}
                        </Button>
                    )}
                </List.Item>
            )}
        />
    );

    return (
        <>
            {isMobile ? renderMobileList() : (
            <Table
                size={'small'}
                dataSource={logs}
                rowKey={'id'}
                columns={[
                    {
                        // Tarih ve kullanıcı tek sütunda alt alta: ikisi de "bu kaydı kim, ne zaman"
                        // sorusunun parçası ve ayrı sütun olarak yer israfıydı.
                        key: 'when',
                        title: t('Created Date'),
                        width: 190,
                        render: (val, row) => (
                            <>
                                <div style={{ whiteSpace: 'nowrap' }}>
                                    {new Date(row.createdDate).toLocaleString()}
                                </div>
                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                    {row?.user?.name}
                                </Typography.Text>
                            </>
                        )
                    },
                    {
                        // Açıklama tek satır; tamamı ipucu olarak gösteriliyor.
                        dataIndex: 'description',
                        key: 'description',
                        title: t('Description'),
                        ellipsis: true,
                        render: (text, row) => {
                            const content = renderDescription(row);
                            return (
                                <div
                                    title={typeof content === 'string' ? content : undefined}
                                    style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                >
                                    {content}
                                </div>
                            );
                        }
                    },
                    {
                        key: 'data',
                        title: t('Data'),
                        width: 90,
                        align: 'center',
                        render: (val, row) => (row?.data ? (
                            <Button size={'small'} onClick={() => setDetail(row)}>{t('Show')}</Button>
                        ) : null)
                    }
                ]}
            />
            )}

            <Modal
                open={!!detail}
                onCancel={() => setDetail(null)}
                title={detail ? `${t('Data')} — ${new Date(detail.createdDate).toLocaleString()}` : t('Data')}
                width={'min(820px, 96vw)'}
                style={{ top: 20 }}
                footer={<Button onClick={() => setDetail(null)}>{t('Close')}</Button>}
                destroyOnClose
            >
                <div style={{ maxHeight: '62vh', overflow: 'auto' }}>
                    {detail && renderData(detail)}
                </div>
            </Modal>
        </>
    )
}